<template>
    <div class="news-section pt-100 pb-70">
        <div class="container">
            <div class="section-title section-title-lg">
                <small>{{ $t('news.section.subtitle') }}</small>
                <h2>{{ $t('news.section.title') }}</h2>
            </div>
            <div class="row">
                <div
                    class="col-md-6 col-lg-4 pb-30"
                    v-for="card in blogCards"
                    :key="card.id"
                >
                    <div class="blog-card">
                        <div class="blog-card-image">
                            <router-link :to="card.route">
                                <img v-lazy="cardImage(card.image)" :alt="card.title">
                            </router-link>
                        </div>
                        <div class="blog-card-text">
                            <div class="blog-category">{{ categoryLabel(card.category) }}</div>
                            <h3>
                                <router-link :to="card.route">
                                    {{ card.title }}
                                </router-link>
                            </h3>
                            <div class="blog-card-entry">
                                <div class="blog-entry-text">
                                    <p>{{ card.date }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Blog',
    computed: {
        blogCards() {
            const cards = this.$t('news.cards')
            return Array.isArray(cards) ? cards : []
        }
    },
    methods: {
        categoryLabel(categoryKey) {
            return this.$t(`news.categories.${categoryKey}`) || categoryKey
        },
        cardImage(imageName) {
            if (!imageName) return ''
            return this.$ossImg(imageName)
        }
    }
}
</script>

<style scoped>
.blog-card {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.blog-card-text {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 120px; /* Ensure the text area has a minimum height */
}

.blog-card-text h3 {
    flex: 1;
    display: flex;
    align-items: flex-start;
    min-height: 60px; /* Keep two-line titles readable */
    line-height: 1.4;
}

.blog-card-text h3 a {
    display: block;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
}

.blog-category {
    display: inline-block;
    font-weight: 700;
    
    /* padding: 4px 12px;
    border-radius: 20px;
    margin-bottom: 10px; */
    width: fit-content;
}

.blog-card-entry {
    margin-top: auto; /* Push the date to the bottom */
}
</style>
